import img1 from '../../assets/img/home2/s1.webp';
import img2 from '../../assets/img/home2/s2.webp';
import img3 from '../../assets/img/home2/s3.webp';
import img4 from '../../assets/img/home2/s4.webp';
import img5 from '../../assets/img/home2/s5.webp';
import img6 from '../../assets/img/home2/s6.webp';

const servicesTwoData = [
  {
    id: 'svc2-1',
    img: img1,
    title: 'Renovation & Interior Fit-Out',
    desc: 'Upgrade your space without stress. We manage everything from design to handover — modern designs, premium finishes, and on-time delivery with zero hassle.',
    cta: 'Start Your Renovation Today',
  },
  {
    id: 'svc2-2',
    img: img2,
    title: 'AC Services',
    desc: 'Stay cool and comfortable with reliable, energy-efficient AC solutions — fast repairs, new installations, and preventive maintenance to reduce bills.',
    cta: 'Book Your AC Service Now',
  },
  {
    id: 'svc2-3',
    img: img3,
    title: 'MEP Services',
    desc: 'Keep your essential systems running safely and efficiently with expert electrical, plumbing, and fault detection solutions.',
    cta: 'Get Expert MEP Support',
  },
  {
    id: 'svc2-4',
    img: img4,
    title: 'Finishing Works',
    desc: 'Achieve flawless finishes with precision flooring, high-quality tiling, smooth paintwork, and waterproofing for lasting results.',
    cta: 'Upgrade Your Finishing Today',
  },
  {
    id: 'svc2-5',
    img: img5,
    title: 'Gypsum Works',
    desc: 'Create modern, elegant interiors with custom gypsum partitions, false ceilings, and decorative designs — fast installation with minimal mess.',
    cta: 'Transform Your Space Now',
  },
  {
    id: 'svc2-6',
    img: img6,
    title: 'AMC (Annual Maintenance Contracts)',
    desc: 'Enjoy hassle-free maintenance all year with scheduled inspections, priority response, and customized plans to reduce repair costs.',
    cta: 'Choose Your AMC Plan Today',
  },
];

export default servicesTwoData;